import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IRequirementMast } from "../../../models/RequirementMast";
import { Fetch } from "../../../shared/Fetch";
import { useEffect, useState } from "react";
import { IBranchMastDropdown, ICityMastDropdown, IClientCompanyDropdown, ICompanyMastDropdown, ICountryMastDropdown, IStateMastDropdown, IUniversityDropdown, IUsersDropdown, IVisaDropdown } from "../../../models/IDropdown";
import { useForm } from "react-hook-form";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";
import { JVInput } from "../../../shared/JVInput";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVRadioBtn } from "../../../shared/JVRadioBtn";
// import { JVDate } from "../../../shared/JVDate";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { EmptySubmission } from "../EmptySubmission";
import { CblType, NoticePeriod, Experience, TaxTerm } from "../../../models/FDropdown";
import { IConsultantMast, IConsultantRef } from "../../../models/ConsultantMast";
import { JVInputCheck } from "../../../shared/JVInputCheck";
import { AutoComplete } from "primereact/autocomplete";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { IClientContactPerson } from "../../../models/ClientContactPerson";
import { IRecruiterRequirements } from "../../../models/RecruiterRequirements";
import { FileUpload, FileUploadHandlerParam } from 'primereact/fileupload';
import { Req } from "../../../shared/Req";
import { baseUrl } from "../../../shared/Fetch";
import { JVInputMask } from "../../../shared/JVInputMask";
import { IConsSubmission, SubmissionsTable } from "./SubmissionsTable";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { JVSunEditor } from "../../../shared/JVSuneditor";
import { Dropdown } from 'primereact/dropdown';
import { IAllRequirements } from "../../../models/AllRequirements";
import { MultiSelect } from "primereact/multiselect";
import { JVDate } from "../../../shared/JVDate";
import { ILogin } from "../../../models/Login";

export interface IReqFilter {
    fromDate?: Date | null
}
export const EmptyFilter: IReqFilter = {
    fromDate: new Date,
}


const emailSchema = yup.object().shape({
    email: yup.string().required().email()
});
const idSchema = yup.object().shape({
    id: yup.number().required().min(1)
});

const schema = yup.object({
    consultant_Name: yup.string().required(),
    consultant_Email_ID: yup.string().required().email(),
    consultant_Home_No: yup.string().required(),
    consultant_Job_Title: yup.string().required(),
    visa_Status: yup.number().min(1).required(),
    state: yup.object().shape({
        state_ID: yup.number().min(1, "State is required*").required("State is required*"),
        state_Name: yup.string().required()
    }),
    city: yup.object().shape({
        city_ID: yup.number().min(1, "City is required*").required("City is required*"),
        city_Name: yup.string().required()
    }),
    total_Experience: yup.number().min(1).required(),
    availability: yup.string().required(),
    faceToFaceInterview: yup.string().required(),
    hourly_Rate: yup.number().required(),
    tax_Term: yup.string().required(),
    // payment_Term:yup.number().required(),
    // required if tax_Term = "C2C with Benefits";
    payment_Term: yup.number().when('tax_Term', val => {
        return (val === "1099 All Inclusive" || val === "1099 with Benefits" || val === "W2 All Inclusive" || val === "W2 with Benefits") ?
            yup.number().min(1).required("Payment Term is Required").nullable() :
            yup.number().nullable();
    }),
    contact_Person_EmailID: yup.string().when('tax_Term', val => {
        return (val === "C2C with Benefits" || val === "C2C All Inclusive") ?
            yup.string().email().required() :
            yup.string();
    }),
    company: yup.object().when('tax_Term', val => {
        return (val === "C2C with Benefits" || val === "C2C All Inclusive") ?
            yup.object().shape({
                vendor_Company_ID: yup.number().min(1, "Employer Company is required*").required("Employer Company is required*"),
                vendor_Company_Name: yup.string().required()
            }) :
            yup.object().shape({
                vendor_Company_ID: yup.number(),
                vendor_Company_Name: yup.string()
            });
    }),
    contact_Person_Name: yup.string().when('tax_Term', val => {
        return (val === "C2C with Benefits" || val === "C2C All Inclusive") ?
            yup.string().required() :
            yup.string();
    }),
    phone_No: yup.string().when('tax_Term', val => {
        return (val === "C2C with Benefits" || val === "C2C All Inclusive") ?
            yup.string().required() :
            yup.string();
    }),

    degree: yup.string(),
    university_Name: yup.string(),
    passoutYear: yup.string(),
    country: yup.object().shape({
        country_ID: yup.number(),
        country_Name: yup.string()
    }),
    // dob: yup.string(),
    ssn: yup.string(),
    linkedin: yup.string().url().nullable(),
    submissionType: yup.string(),
    annual_Salary: yup.string(),

    r1_Ref_ID: yup.number().nullable(),
    r1_Company_Name: yup.string().nullable(),
    r1_POC_Name: yup.string().nullable(),
    r1_Phone: yup.string().nullable(),
    r1_Email: yup.string().email("invalid email").nullable(),

    r2_Ref_ID: yup.number().nullable(),
    r2_Company_Name: yup.string().nullable(),
    r2_POC_Name: yup.string().nullable(),
    r2_Phone: yup.string().nullable(),
    r2_Email: yup.string().email("invalid email").nullable(),

    r3_Ref_ID: yup.number().nullable(),
    r3_Company_Name: yup.string().nullable(),
    r3_POC_Name: yup.string().nullable(),
    r3_Phone: yup.string().nullable(),
    r3_Email: yup.string().email("invalid email").nullable()
});

interface IProps {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reqFilter?: IReqFilter,
    setReqFilter?: (reqFilter: IReqFilter) => void,
    //singleData: any
}



export const FloatReqSubmision = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [refCount, setRefCount] = useState(1);
    const [data, setData] = useState<IRequirementMast>();
    const [selectedReq, setSelectedReq] = useState<IAllRequirements | null>(null);
    const [floatedReq, setFloatedReq] = useState<Array<IAllRequirements>>([]);
    const [loadFloatedReqL, setLoadFloatedReqL] = useState<boolean>(false);
    const [selectedRec, setSelectedRec] = useState<IUsersDropdown | null>(null);
    const [recruitersList, setRecruitersList] = useState<Array<IUsersDropdown>>([]);
    const [reqFilter, setReqFilter] = useState<IReqFilter>(EmptyFilter);
    const [resumeFile, setResumeFile] = useState<File | null | any>(null);

    const PaymentTerm = [
        { name: "By Weekly", value: 1 },
        { name: "Net Fifteen", value: 2 },
        { name: "Net Thirty", value: 3 },
        { name: "Net Forty Five", value: 4 },
        { name: "Net Sixty", value: 5 },
    ]

    useEffect(() => {
        if (props.open) loadFloatedReq();
        if (selectedReq?.req_ID != null) loadData();
    }, [selectedReq, reqFilter]);

    const loadData = async () => {
        const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${selectedReq?.req_ID}`, props.toast);
        if (response) {
            const data: IRequirementMast = await response.json();
            setData(data);
        }
    }

    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [countries, setCountries] = useState<Array<ICountryMastDropdown>>();
    const [visa, setVisa] = useState<Array<IVisaDropdown>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [universities, setUniversities] = useState<Array<IUniversityDropdown>>();
    const [university, setUniversity] = useState<IUniversityDropdown | undefined | string>(undefined);
    const [resume, setResume] = useState(false);
    const [additionInfo, setAdditionInfo] = useState("");
    const [disableEmployeeDetails, setDisableEmployeeDetails] = useState(false);
    const [disablePaymentsTerm, setDisablePaymentsTerm] = useState(true);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');



    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<IConsultantMast>({
        resolver: yupResolver(schema),
        defaultValues: EmptySubmission,
        shouldFocusError: false
    });

    const [subTable, setSubTable] = useState({ data: [], open: false } as { data: Array<IConsSubmission>, open: boolean });

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "tax_Term") {
                if (value.tax_Term === "C2C with Benefits" || value.tax_Term === "C2C All Inclusive") {
                    setDisableEmployeeDetails(false);
                } else {
                    setDisableEmployeeDetails(true);
                }
            }
            if (name === "tax_Term") {
                if (value.tax_Term === "1099 All Inclusive" || value.tax_Term === "1099 with Benefits" || value.tax_Term === "W2 All Inclusive" || value.tax_Term === "" || value.tax_Term === "W2 with Benefits") {
                    setDisablePaymentsTerm(false)
                } else {
                    setDisablePaymentsTerm(true)
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);


    const hideSubTable = () => {
        setSubTable({ data: subTable.data, open: false });
    };

    useEffect(() => {
        if (university) {
            let un: string | undefined = undefined;
            if (typeof (university) === 'string') {
                un = university;
            } else {
                un = university?.university_Name;
            }
            setValue("university_Name", un);
        } else {
            setValue("university_Name", undefined);
        }
        // console.log(university, control._formValues.university_Name);
    }, [university]);

    const loadCities = async (filter: string | null) => {
        if (control._formValues.state?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
            if (response) {
                const data: Array<ICityMastDropdown> = await response.json();
                setCities(data);
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const loadCountries = async (filter: string | null) => {
        const response = await Fetch("Dropdown/countries", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<ICountryMastDropdown> = await response.json();
            setCountries(data);
        }
    }
    const completeMethodCountries = (event: { query: string }) => {
        loadCountries(event.query);
    }

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies_emp_details", "GET", null, `filter=${encodeURIComponent(JSON.stringify(filter))}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodEC = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }

    const loadVisa = async () => {
        const response = await Fetch("Dropdown/visa", "GET", null, null, null);
        if (response) {
            const data: Array<IVisaDropdown> = await response.json();
            setVisa(data);
        }
    }

    const loadUniversities = async (filter: string | null) => {
        const response = await Fetch("Dropdown/universities", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IUniversityDropdown> = await response.json();
            setUniversities(data);
        }
    }
    const completeMethodUniversities = (event: { query: string }) => {
        loadUniversities(event.query);
    }

    useEffect(() => {
        loadVisa();
    }, []);

    const fillSubVendor = async () => {
        setLoading(true);
        if (control._formValues.contact_Person_EmailID === "") return;
        const email = control._formValues.contact_Person_EmailID;
        if (!(email?.includes("gmail") || email?.includes("outlook")
            || email?.includes("protonmail") || email?.includes("aol")
            || email?.includes("yahoo") || email?.includes("hotmail")
            || email?.includes("rediff"))) {
            const valid = await emailSchema.isValid({
                email: control._formValues.contact_Person_EmailID,
            });
            if (valid) {
                const response = await Fetch("Sub_Vendor_Contact_Person_Mast/email", "GET", null, `email=${control._formValues.contact_Person_EmailID}`, props.toast);
                if (response) {
                    const data: Array<IClientContactPerson> = await response.json();

                    if (data.length > 0) {
                        setValue("contact_Person_EmailID", data[0].contact_Person_EmailID);
                        setValue("contact_Person_Name", data[0].contact_Person_Name);
                        setValue("phone_No", data[0].phone_No);
                        setValue("vendor_Company_ID", data[0].vendor_Company_ID);
                        setValue("company", { vendor_Company_ID: data[0].vendor_Company_ID, vendor_Company_Name: data[0].vendor_Company_Name });
                    } else {
                        setValue("contact_Person_Name", '');
                        setValue("phone_No", undefined);
                        setValue("vendor_Company_ID", undefined);
                        setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: '' });
                        props.toast.current.show({ severity: 'info', content: "No Employer Found resistered with this Email-ID" });
                    }
                }
            }
            else props.toast.current.show({ severity: 'error', content: "Please Enter a Valid Employer Email-ID" });
        } else {
            setValue("contact_Person_Name", '');
            setValue("phone_No", undefined);
            setValue("vendor_Company_ID", undefined);
            setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: '' });
            props.toast.current.show({ severity: 'error', content: "Employer Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc." });
        }
        setLoading(false);
    }

    const fillSub = async (identity: string, isID: boolean) => {
        setLoading(true);
        let query = `req_id=${selectedReq?.req_ID}&`;
        if (isID) query += `consultant_id=${control._formValues.identity}`;
        else query += `consultant_email=${control._formValues.identity}`;
        setUniversity(undefined);

        const responseSub = await Fetch("Consultant_Mast/consultantSub", "GET", null, query, props.toast);
        if (responseSub) {
            const data: Array<IConsSubmission> = await responseSub.json();
            setSubTable({ data: data, open: subTable.open });
        }
        const response = await Fetch("Consultant_Mast", "GET", null, query, props.toast);
        if (response) {
            const _data: Array<IConsultantMast> = await response.json();
            // console.log(_data);
            const data = _data[0];
            if (data.consultant_Status !== "00.01" && data.consultant_Status !== "00.02") {
                reset(data);
                setValue("identity", data.consultant_Email_ID);
                setValue("state", { state_ID: 1, state_Name: data.consultant_State });
                setValue("city", { city_ID: data.consultant_City || 0, city_Name: data.city_Name || "" });
                setValue("country", { country_ID: data.consultant_Country, country_Name: data.country_Name });
                setValue("company", { vendor_Company_ID: data.vendor_Company_ID, vendor_Company_Name: data.vendor_Company_Name });
                setValue("faceToFaceInterview", "No");
                setValue("tax_Term", "C2C with Benefits");
                setUniversity({ university_ID: data.university_ID, university_Name: data.university_Name });
                const _dobArray = data.dob?.split("-");
                if (_dobArray) {
                    setValue("dobmm", _dobArray[0]);
                    setValue("dobdd", _dobArray[1]);
                    setValue("dobyyyy", _dobArray[2]);
                }
                setRefCount(_data.length);
                if (_data.length > 1) {
                    _data.forEach((d, i) => {
                        if (i === 0) {
                            setValue("r1_Ref_ID", d.r1_Ref_ID);
                            setValue("r1_Company_Name", d.r1_Company_Name);
                            setValue("r1_POC_Name", d.r1_POC_Name);
                            setValue("r1_Phone", d.r1_Phone);
                            setValue("r1_Email", d.r1_Email);
                        } else if (i === 1) {
                            setValue("r2_Ref_ID", d.r1_Ref_ID);
                            setValue("r2_Company_Name", d.r1_Company_Name);
                            setValue("r2_POC_Name", d.r1_POC_Name);
                            setValue("r2_Phone", d.r1_Phone);
                            setValue("r2_Email", d.r1_Email);
                        } else if (i === 2) {
                            setValue("r3_Ref_ID", d.r1_Ref_ID);
                            setValue("r3_Company_Name", d.r1_Company_Name);
                            setValue("r3_POC_Name", d.r1_POC_Name);
                            setValue("r3_Phone", d.r1_Phone);
                            setValue("r3_Email", d.r1_Email);
                        }
                    });
                }
            } else {
                reset(EmptySubmission);
                setValue("identity", identity);
                !isID && setValue("consultant_Email_ID", identity);
                props.toast.current.show({ severity: 'info', content: data.consultant_Job_Title });
            }
        }
        setLoading(false);
    }

    const fillSubmission = async () => {
        if (control._formValues.identityType === "Email ID") {
            const valid = await emailSchema.isValid({
                email: control._formValues.identity,
            });
            if (valid) {
                const email = control._formValues.identity;
                fillSub(email, false);
            }
            else props.toast.current.show({ severity: 'error', content: "Please Enter a Valid Email-ID" });
        } else if (control._formValues.identityType === "Cons. ID") {
            const valid = await idSchema.isValid({
                id: control._formValues.identity,
            });
            if (valid) {
                const id = control._formValues.identity;
                fillSub(id, true);
            }
            else props.toast.current.show({ severity: 'error', content: "Please Enter a Valid Consultant-ID" });
        }
    }

    const saveToDB = async (body: IConsultantMast) => {
        setLoading(true);
        if (body.dobdd === undefined) body.dobdd = "";
        if (body.dobmm === undefined) body.dobmm = "";
        if (body.dobyyyy === undefined) body.dobyyyy = "";
        const consultant_Mast: IConsultantMast = {
            consultant_ID: body.consultant_ID,
            consultant_Name: body.consultant_Name,
            consultant_Email_ID: body.consultant_Email_ID,
            consultant_Home_No: body.consultant_Home_No,
            consultant_Job_Title: body.consultant_Job_Title,
            visa_Status: body.visa_Status,
            consultant_State: body.state?.state_Name,
            consultant_City: body.city?.city_ID,
            total_Experience: body.total_Experience,
            availability: body.availability,
            hourly_Rate: body.hourly_Rate,
            dob: body.dobmm + "-" + body.dobdd + "-" + body.dobyyyy,
            ssn: body.ssn,
            linkedin: body.linkedin,
            consultant_Country: body.country?.country_ID,
            annual_Salary: body.annual_Salary ? body.annual_Salary : undefined,
            consultant_Status: body.university_Name
        }
        const consultant_Education_Details: IConsultantMast = {
            degree: body.degree,
            passoutYear: body.passoutYear
        }
        const consultant_Submittal_Logs: IConsultantMast = {
            requirement_ID: selectedReq?.req_ID,
            faceToFaceInterview: body.faceToFaceInterview,
            tax_Term: body.tax_Term,
            payment_Term: body.payment_Term,
            submissionType: body.submissionType,
            buying_Rate: body.hourly_Rate?.toString(),
            addition_Info: additionInfo
        }
        const sub_Vendor_Contact_Person_Mast: IConsultantMast = {
            contact_Person_EmailID: body.contact_Person_EmailID,
            contact_Person_Name: body.contact_Person_Name,
            phone_No: body.phone_No,
            vendor_Company_ID: body.company?.vendor_Company_ID
        }
        const consultant_References_List: Array<IConsultantRef> = [];
        for (let i = 0; i < refCount; i++) {
            if (i === 0) {
                const element: IConsultantRef = {
                    ref_ID: body.r1_Ref_ID ? body.r1_Ref_ID : undefined,
                    consultant_ID: body.consultant_ID,
                    company_Name: body.r1_Company_Name,
                    poC_Name: body.r1_POC_Name,
                    phone: body.r1_Phone,
                    email: body.r1_Email
                };
                consultant_References_List.push(element);
            } else if (i === 1) {
                const element: IConsultantRef = {
                    ref_ID: body.r2_Ref_ID ? body.r2_Ref_ID : undefined,
                    consultant_ID: body.consultant_ID,
                    company_Name: body.r2_Company_Name,
                    poC_Name: body.r2_POC_Name,
                    phone: body.r2_Phone,
                    email: body.r2_Email
                };
                consultant_References_List.push(element);
            } else if (i === 2) {
                const element: IConsultantRef = {
                    ref_ID: body.r3_Ref_ID ? body.r3_Ref_ID : undefined,
                    consultant_ID: body.consultant_ID,
                    company_Name: body.r3_Company_Name,
                    poC_Name: body.r3_POC_Name,
                    phone: body.r3_Phone,
                    email: body.r3_Email
                };
                consultant_References_List.push(element);
            }
        }
        const consultant = {
            consultant_Mast,
            consultant_Education_Details,
            consultant_Submittal_Logs,
            sub_Vendor_Contact_Person_Mast,
            consultant_References_List,

        }
        // console.log(consultant);
        let loginid: number = selectedRec?.login_ID || loginObj.id;

        const formData = new FormData();
        formData.append('resume', resumeFile);
        formData.append('consultant1', JSON.stringify(consultant));
        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}Consultant_Mast?loginID=${loginid}`, params);
        //const response = await Fetch("Consultant_Mast", "POST", consultant, `loginID=${loginid}`, props.toast);

        if (response.status === 400) {
            const message = await response.text();
            props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            setLoading(false);
        }
        if (response) {
            const data: any = await response.json();
            if (data.consultant_Status === "00.03") {

                // if (data.target_Completed === true) { props.ShowCelebration(); }
                props.toast.current.show({ severity: 'success', content: data.consultant_Job_Title });
                onHide();
            } else if (data.consultant_Status === "00.02" || data.consultant_Status === "00.04" || data.consultant_Status === "00.05") {
                props.toast.current.show({ severity: 'error', content: data.consultant_Job_Title });
            } else if (data.error) {
                props.toast.current.show({ severity: 'error', content: data.error });
                if ((data.error.split(" ")[0] === "Submitted" && data.error.split(" ")[1] === "Successfully.") && data.target_Completed === true) {
                    onHide();
                }
                // if (data.target_Completed === true) { props.ShowCelebration(); }
            }
        }
        setLoading(false);
    }

    function onSubmit(data: IConsultantMast) {
        const email = data.contact_Person_EmailID;
        if (disableEmployeeDetails) {
            if (resume) saveToDB(data);
            else props.toast.current.show({ severity: 'error', content: "Please Upload the Consultant Resume First." });
        } else {
            if (!(email?.includes("gmail") || email?.includes("outlook")
                || email?.includes("protonmail") || email?.includes("aol")
                || email?.includes("yahoo") || email?.includes("hotmail")
                || email?.includes("rediff"))) {
                if (resume) saveToDB(data);
                else props.toast.current.show({ severity: 'error', content: "Please Upload the Consultant Resume First." });
            } else {
                setValue("contact_Person_Name", '');
                setValue("phone_No", undefined);
                setValue("vendor_Company_ID", undefined);
                setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: '' });
                props.toast.current.show({ severity: 'error', content: "Employer Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc." });
            }
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptySubmission);
        setDisablePaymentsTerm(true);
        setResume(false);
        setRefCount(1);
        setSubTable({ data: [], open: false });
        setAdditionInfo("");
    }

    const dFooter = () => {
        return (<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            <Button loading={loading} className="p-button-sm my-1" form="submissionForm" label="SAVE" type="submit"></Button>
            <Button className="p-button-sm p-button-outlined my-1" label="CLEAR" onClick={() => { reset(EmptySubmission); setUniversity(undefined); setRefCount(1); setSubTable({ data: [], open: false }); }} type="button"></Button>
        </div>);
    }

    const resumeUploade = (event: FileUploadHandlerParam) => {
        // console.log(event.files[0].type);
        if (event.files[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            if (event.files[0].size > 1024 * 1024 * 2) {
                // console.log(event.files[0].size);
                props.toast.current.show({ severity: 'error', content: "DOCX File should be less than 2 MB." });
                event.options.clear();
            } else {
                setResume(true);
                setResumeFile(event.files[0]);
                props.toast.current.show({ severity: 'success', content: "Resume Selected." });
                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A DOCX File." });
            event.options.clear();
        }
    }

    const uploadeResume = async (resume: File) => {
        let formData = new FormData();
        formData.append("resume", resume);

        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        setLoading(true);
        const response = await fetch(`${baseUrl}Consultant_Mast/resume?loginID=${loginObj.id}`, params);
        if (response) {
            setResume(true);
            props.toast.current.show({ severity: 'success', content: "Resume Uploaded Successfully." });
            setLoading(false);
        } else setLoading(false);
    }

    const loadFloatedReq = async () => {
        setLoadFloatedReqL(true);
        setRecruitersList([]);
        const response = await Fetch("Float/getAllCompFloatReq", "GET", null, `filter=` + encodeURIComponent(JSON.stringify(reqFilter)), props.toast);
        if (response) {
            const data: Array<IAllRequirements> = await response.json();
            setFloatedReq(data);
            setLoadFloatedReqL(false);
        } else setLoadFloatedReqL(false);
    }

    const loadRecruiterForFloatSub = async (company: number) => {
        const response = await Fetch("Dropdown/RecruiterList", "GET", null, `user_Type=recruiter&company_ID=${company}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            console.log(data);
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruitersList(data);
        }


    }





    return (
        <>
            <div className="p-fluid formgrid grid">
                {(selectedRec === null || selectedRec?.login_ID === 0) && <div className="flex justify-content-center w-full"><h3 style={{ color: "red", fontFamily: "sans-serif", fontWeight: "lighter" }}>Select Req ID</h3></div>}

                <Filter reqFilter={reqFilter} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} />

                {loadFloatedReqL === true && <div className="field col-12 md:col-2">Loading Requirement...</div>}
                {loadFloatedReqL === false && <div className="field col-12 md:col-2">
                    <div>Req ID<span style={{ color: 'red' }}>*</span></div>
                    <Dropdown value={selectedReq} onChange={(e) => {
                        console.log(e);
                        setSelectedReq(e.value);
                        loadRecruiterForFloatSub(e.value?.company_ID);
                    }} options={floatedReq} optionLabel="req_ID" placeholder="Select Req ID"
                        filter className="w-full" />
                </div>}


                {/* <div className="field col-12 md:col-4">
                    <div>Recruiter<span style={{ color: 'red' }}>*</span></div>
                    <Dropdown value={selectedRec} filter disabled={selectedReq === null} onChange={(e) => setSelectedRec(e.value)} options={recruitersList} optionLabel="user_Name" placeholder="Select a Recruiter" className="w-full" />
                </div> */}
                <RecruiterSelectForm setSelectedRec={(item: IUsersDropdown | null) => setSelectedRec(item)} selectedReq={selectedReq} />
            </div>
            <div style={{ border: "1px solid #2196F3", width: "100%", marginTop: "-10px", height: "0px" }}></div>
            <div className="field col-12 md:col-12" style={{ display: 'flex', gap: '10px' }}></div>
            {/* selectedRec != null  */}
            {selectedReq != null && <>
                {data && <Req req={data} />}
                <form id="submissionForm" onSubmit={handleSubmit(onSubmit)}>
                    <div style={{ margin: '10px 0', width: '100%' }}></div>
                    <div className="p-fluid formgrid grid">
                        <JVDropdown column={3} control={control} name="identityType" options={[
                            { name: "Email ID" },
                            { name: "Cons. ID" }
                        ]} optionLabel="name" optionValue="name" placeholder="--Select--" />
                        <JVInputCheck required func={fillSubmission} control={control} name="identity" />
                        {subTable.data.length > 0 && <div className="field col-12 md:col-1">
                            <Button type="button" label={subTable.data.length.toString()} className="p-button-rounded p-button-info"
                                onClick={() => { if (subTable.data.length > 0) setSubTable({ data: subTable.data, open: true }) }} />
                        </div>}
                    </div>

                    <Accordion multiple activeIndex={[0, 1]}>
                        <AccordionTab header="Consultant Required Details:">
                            <div className="p-fluid formgrid grid">
                                <JVInput required placeholder="Consultant Name" column={3} control={control} name="consultant_Name" error={errors.consultant_Name?.message} />
                                <JVInput required disabled placeholder="Email" column={3} control={control} name="consultant_Email_ID" error={errors.consultant_Email_ID?.message} />
                                <JVInputMask required mask="(999) 999-9999" column={3} placeholder="Phone" control={control} name="consultant_Home_No" error={errors.consultant_Home_No?.message} />
                                <JVInput required placeholder="Job Title" column={3} control={control} name="consultant_Job_Title" error={errors.consultant_Job_Title?.message} />

                                <JVDropdown required column={3} control={control} name="visa_Status" error={errors.visa_Status?.message} options={visa} optionLabel="visa_Name" optionValue="visaId" placeholder="--Select Visa--" />
                                <JVDropdownInput required column={3} completeMethod={completeMethodStates} control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                                <JVDropdownInput required column={3} completeMethod={completeMethodCities} control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />
                                <JVDropdown required column={3} control={control} name="total_Experience" error={errors.total_Experience?.message} options={Experience} optionLabel="name" optionValue="name" placeholder="--Select Total Exp--" />

                                <JVDropdown required column={3} control={control} name="availability" error={errors.availability?.message} options={NoticePeriod} optionLabel="name" optionValue="value" placeholder="--Select NoticePeriod--" />
                                <JVInput required placeholder="Buying Rate" type={"number"} column={3} control={control} name="hourly_Rate" error={errors.hourly_Rate?.message} />
                                <JVDropdown required column={3} control={control} name="tax_Term" error={errors.tax_Term?.message} options={TaxTerm} optionLabel="name" optionValue="name" placeholder="--Select TaxTerm--" />
                                {!disablePaymentsTerm && <JVDropdown required column={3} disabled={disablePaymentsTerm} control={control} name="payment_Term" error={errors.payment_Term?.message} options={PaymentTerm} optionLabel="name" optionValue="value" placeholder="--Select PaymentTerm--" />}
                                <JVRadioBtn inline label="F2F Interview" required data={["Yes", "No"]} column={3} control={control} name="faceToFaceInterview" error={errors.faceToFaceInterview?.message} />
                            </div>
                        </AccordionTab>
                        {!disableEmployeeDetails && <AccordionTab header="Employer Details:">
                            <div className="p-fluid formgrid grid">
                                <JVInput required disabled={disableEmployeeDetails} onBlur={fillSubVendor} placeholder="Employer Email" column={4} control={control} name="contact_Person_EmailID" error={errors.contact_Person_EmailID?.message} />
                                <JVDropdownInput required disabled={disableEmployeeDetails} column={4} completeMethod={completeMethodEC} control={control} name="company" error={errors.company?.vendor_Company_ID?.message} options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Employer Company" />
                                <JVInput required disabled={disableEmployeeDetails} placeholder="Contact Name" column={4} control={control} name="contact_Person_Name" error={errors.contact_Person_Name?.message} />
                                <JVInputMask required disabled={disableEmployeeDetails} mask="(999) 999-9999" column={4} placeholder="Employer Phone" control={control} name="phone_No" error={errors.phone_No?.message} />
                            </div>
                        </AccordionTab>}
                        <AccordionTab header="Education & Other Details:">
                            <div className="p-fluid formgrid grid">
                                <JVInput placeholder="Degree" column={3} control={control} name="degree" error={errors.degree?.message} />
                                <div className="field col-12 md:col-4">
                                    <div className="p-inputgroup">
                                        <AutoComplete suggestions={universities}
                                            completeMethod={completeMethodUniversities} field='university_Name' value={university}
                                            placeholder="Search/Type University" onChange={(e) => setUniversity(e.value)} />
                                    </div>
                                    <small className="p-error" >{errors.university_Name?.message}</small>
                                </div>
                                <JVInput placeholder="Passing Year" column={3} control={control} name="passoutYear" error={errors.passoutYear?.message} />
                                <JVDropdownInput column={3} completeMethod={completeMethodCountries} control={control} name="country" error={errors.country?.country_ID?.message} options={countries} optionLabel="country_Name" placeholder="Search Country" />

                                {/* <JVDate maxDate={new Date} placeholder="Date Of Birth" column={3} control={control} name="dob" error={errors.dob?.message} /> */}
                                <div className="field col-12 md:col-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <JVInputMask mask="99" column={3} placeholder="MM" control={control} name="dobmm" />
                                    <JVInputMask mask="99" column={3} placeholder="DD" control={control} name="dobdd" />
                                    <JVInputMask mask="9999" column={3} placeholder="YYYY" control={control} name="dobyyyy" />
                                </div>

                                <JVInput placeholder="SSN" column={3} type={"number"} control={control} name="ssn" error={errors.ssn?.message} />
                                <JVInput placeholder="Linkedin" column={3} control={control} name="linkedin" error={errors.linkedin?.message} />

                                <JVDropdown column={3} control={control} name="submissionType" error={errors.submissionType?.message} options={CblType} optionLabel="name" optionValue="name" placeholder="--Select JobType--" />
                                <JVInput placeholder="Salary" type={"number"} column={3} control={control} name="annual_Salary" error={errors.annual_Salary?.message} />
                            </div>
                        </AccordionTab>
                        <AccordionTab header="References:">
                            <div className="p-fluid formgrid grid">
                                <JVInput placeholder="Company Name" column={4} control={control} name="r1_Company_Name" />
                                <JVInput placeholder="POC Name" column={4} control={control} name="r1_POC_Name" />
                                <JVInputMask mask="(999) 999-9999" column={4} placeholder="Phone" control={control} name="r1_Phone" />
                                <JVInput placeholder="Email" column={4} control={control} name="r1_Email" error={errors.r1_Email?.message} />
                            </div>
                            {refCount > 1 && <div className="p-fluid formgrid grid">
                                <JVInput placeholder="Company Name" column={4} control={control} name="r2_Company_Name" />
                                <JVInput placeholder="POC Name" column={4} control={control} name="r2_POC_Name" />
                                <JVInputMask mask="(999) 999-9999" column={4} placeholder="Phone" control={control} name="r2_Phone" />
                                <JVInput placeholder="Email" column={4} control={control} name="r2_Email" error={errors.r2_Email?.message} />
                            </div>}
                            {refCount > 2 && <div className="p-fluid formgrid grid">
                                <JVInput placeholder="Company Name" column={4} control={control} name="r3_Company_Name" />
                                <JVInput placeholder="POC Name" column={4} control={control} name="r3_POC_Name" />
                                <JVInputMask mask="(999) 999-9999" column={4} placeholder="Phone" control={control} name="r3_Phone" />
                                <JVInput placeholder="Email" column={4} control={control} name="r3_Email" error={errors.r3_Email?.message} />
                            </div>}
                            {refCount !== 3 && <Button icon="pi pi-plus" type="button" className="p-button-rounded p-button-success" aria-label="Add More"
                                onClick={() => setRefCount(refCount + 1)} />}
                        </AccordionTab>
                        <AccordionTab header="Additional Info:">
                            <div className="p-fluid formgrid grid">
                                <div className="col-12 md:col-12 md:col-6">
                                    {/* <CKEditor editor={ClassicEditor} data={additionInfo} onChange={(event, editor) => { setAdditionInfo(editor.getData()); }} /> */}
                                    <JVSunEditor value={additionInfo} handleChange={setAdditionInfo} />
                                </div>
                            </div>
                        </AccordionTab>
                    </Accordion>
                    <div className="field col-12 md:col-4">
                        <FileUpload chooseLabel="Choose Resume" mode="basic" name="resume" accept=".docx" auto customUpload uploadHandler={resumeUploade} />
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
                        <Button loading={loading} className="p-button-sm my-1" form="submissionForm" label="SAVE" type="submit"></Button>
                        <Button className="p-button-sm p-button-outlined my-1" label="CLEAR" onClick={() => { reset(EmptySubmission); setUniversity(undefined); setRefCount(1); setSubTable({ data: [], open: false }); }} type="button"></Button>
                    </div>
                </form>
                <SubmissionsTable data={subTable.data} hideDialog={hideSubTable} open={subTable.open} toast={props.toast} />
            </>}
        </>
    );
}


const schema2 = yup.object().shape({
    company: yup.number().nullable(),
    branch: yup.number().nullable(),
    recruiter: yup.number().nullable(),
});

interface IProps2 {
    setSelectedRec: (item: IUsersDropdown | null) => void,
    selectedReq: IAllRequirements | null,
}

const RecruiterSelectForm = (props: IProps2) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [disInput, setDisInput] = useState({ comp: true, branch: false, rec: false });
    const [recruiter, setRecruiter] = useState<IUsersDropdown>();

    const { control, handleSubmit, reset, watch } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });
    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const loadRecruiters = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }

        const response = await Fetch("Dropdown/RecruiterList", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    }
    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        // let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList";
        let endPoint = "allBranches";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        // let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";
        let endPoint = "company";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }

    const onSubmit = (data: any) => {
        props.setSelectedRec(data.recruiter);
    };
    const onSubmit2 = (data: any) => {
        if (data.recruiter === 0) {
            props.setSelectedRec(null);
        } else {
            props.setSelectedRec({ login_ID: data.recruiter });
        }
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0) {
                    loadBranches(value.company);
                    loadRecruiters(0, value.company, 0);
                } else {
                    loadBranches();

                    if (control._formValues.branch != 0) {
                        loadRecruiters(control._formValues.branch, 0, 0);
                    } else if (control._formValues.branch == 0) {
                        loadRecruiters(0, 0, 0);
                    }
                }
            }

            if (name === "branch") {
                if (value.branch != 0) {
                    loadRecruiters(value.branch, 0, 0);
                } else {
                    if (control._formValues.company != 0) {
                        loadRecruiters(0, control._formValues.company, 0);
                    } else if (control._formValues.company == 0) {
                        loadRecruiters(0, 0, 0);
                    }
                }
            }

            if (name === "recruiter") {
                if (value.recruiter != 0) {
                    onSubmit2(control._formValues);
                } else {
                    onSubmit2(control._formValues);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadRecruiters(0, 0, 0);
        loadCompanies();
        loadBranches();
        reset({
            company: null,
            branch: null,
            recruiter: null,
        });
    }, []);

    return (
        <>
            {/* <form onSubmit={handleSubmit(onSubmit)}> */}
            {/* {_roles.includes(4) && <JVDropdown disabled={props.selectedReq === null} column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />}
            {_roles.includes(4) && <JVDropdown disabled={props.selectedReq === null} column={6} label="Branch" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />}
            {_roles.includes(4) && <JVDropdown disabled={props.selectedReq === null} column={6} label="Recruiter" control={control} name="recruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" />} */}
            {/* </form> */}
        </>
    );
}

const schema4 = yup.object().shape({
    fromDate: yup.date().nullable(),

});

interface IProps3 {
    reqFilter: IReqFilter,
    setReqFilter: (reqFilter: IReqFilter) => void,
}

export const Filter = (props: IProps3) => {
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, reset, watch } = useForm<IReqFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.reqFilter,
        shouldFocusError: false
    });

    const searchToDB = async (body: IReqFilter) => {
        // onHide();
        let filterData: any = body;
        let emptyFilter: any = EmptyFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setReqFilter(body);
        // console.log(reqFilter);
    }

    function handleSearch(data: IReqFilter) {
        //    console.log(data);
        searchToDB(data);
    }



    return (
        <>
            {/* <form onSubmit={handleSubmit(onSubmit)}> */}
            <JVDate minDate={new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000))} maxDate={new Date} column={6} label=" Date" control={control} name="fromDate" />
            <Button
                icon="pi pi-search"
                className="p-button-rounded p-button-icon-only bg-yellow-500 mt-5 mr-4 -ml-3"
                loading={loading}
                onClick={() => handleSearch(watch())}
            />
            {/* </form> */}
        </>
    );
}

